export const ListingName = ({ name = "" }) => (
  <div className="hidden xl:flex">
    <h2 className="text-xl font-semibold leading-relaxed line-clamp-2">
      {name}
    </h2>
  </div>
);
